import React from "react";

export default function PatientsToolbar({
  search,
  onSearchChange,
  relationFilter,
  onRelationFilterChange,
  genderFilter,
  onGenderFilterChange,
  sortBy,
  onSortByChange,
  showAll,
  onToggleShowAll,
  onAddPatient,
}) {
  return (
    <div className="page-toolbar">
      <div className="page-toolbar-filters">
        <input
          className="filter-input"
          type="text"
          placeholder="Search patients"
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
        />

        <select
          className="filter-select"
          value={relationFilter}
          onChange={(e) => onRelationFilterChange(e.target.value)}
        >
          <option value="all">All relations</option>
          <option value="self">Self</option>
          <option value="mother">Mother</option>
          <option value="father">Father</option>
          <option value="spouse">Spouse</option>
          <option value="child">Child</option>
          <option value="sibling">Sibling</option>
        </select>

        <select
          className="filter-select"
          value={genderFilter}
          onChange={(e) => onGenderFilterChange(e.target.value)}
        >
          <option value="all">All genders</option>
          <option value="male">Male</option>
          <option value="female">Female</option>
          <option value="other">Other</option>
        </select>

        <select
          className="filter-select"
          value={sortBy}
          onChange={(e) => onSortByChange(e.target.value)}
        >
          <option value="recent">Most recent</option>
          <option value="name_asc">Name A-Z</option>
          <option value="name_desc">Name Z-A</option>
          <option value="age_desc">Age high-low</option>
          <option value="age_asc">Age low-high</option>
        </select>
      </div>

      <div className="page-toolbar-actions">
        <button className="btn btn-ghost" type="button" onClick={onToggleShowAll}>
          {showAll ? "Show less" : "See all"}
        </button>

        <button className="btn btn-primary" type="button" onClick={onAddPatient}>
          Add Patient
        </button>
      </div>
    </div>
  );
}